import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUser, getAllWorks, getWorkById } from "../../../data/getters";
import { selectWork } from "../../../data/store/actions/workStoreFunctions";
import { selectClient } from "../../../data/store/actions/clientStoreFunctions";
import {
  fetchCreatedItemsForWork, fetchCreatedTablesForWork, fetchObjectsForWork,
  fetchTables, fetchWorkFilesForWork
} from "../../../data/storeManager";
import { useLanguage } from "../../helpers/LanguageContext";
import { createWorkRow } from "./worksPageUtils";

const EMPTY_WORKS = [];

export default function useWorksPageController() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, dateLocale } = useLanguage();
  const [loading, setLoading] = useState(true);
  const userRole = dispatch(getUser()).role;

  const isUser = String(userRole).toLowerCase() === "user";
  const works = useSelector((state) => state.works || EMPTY_WORKS);

  // Adatok betöltése Redux-ból
  useEffect(() => {
    async function loadWorks() {
      try {
        await dispatch(getAllWorks());
        setLoading(false);
      } catch (error) {
        console.error("Error loading works:", error);
        setLoading(false);
      }
    }
    loadWorks();
  }, [dispatch]);

  const handleRowClick = async (workId) => {
    setLoading(true);
    try {
      dispatch(selectWork(workId));
      fetchTables(workId);
      fetchObjectsForWork(workId);
      fetchCreatedItemsForWork(workId);
      fetchCreatedTablesForWork(workId);
      fetchWorkFilesForWork(workId);
      const clientId = dispatch(getWorkById(workId)).client.clientId;
      dispatch(selectClient(clientId));
      navigate(`/work/${workId}`);
      setLoading(false);
    } catch (error) {
      console.error("Error while selecting work:", error);
      setLoading(false);
    }
  };

  const handleDeleteWork = (workId) => {
    console.log(`Delete work with ID: ${workId}`);
  };

  return {
    t,
    loading,
    isUser,
    workList: works.map((work) => createWorkRow(work, isUser, t, dateLocale)),
    handleRowClick,
    handleDeleteWork
  };
}
